"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerHandshake = void 0;
const endpoints_1 = require("./endpoints");
class ServerHandshake {
    constructor(ipcBus) {
        this.ipcBus = ipcBus;
    }
    async connect(channel) {
        if (this.subscription) {
            return;
        }
        await this.ipcBus.connect();
        this.subscription = this.ipcBus.subscribe(channel + endpoints_1.PING_ENDPOINT, () => {
            this.ipcBus.publish(channel + endpoints_1.PONG_ENDPOINT, {});
        });
        this.ipcBus.publish(channel + endpoints_1.PONG_ENDPOINT, {});
    }
    disconnect() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = void 0;
        }
    }
}
exports.ServerHandshake = ServerHandshake;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmVyLWhhbmRzaGFrZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9oYW5kc2hha2Uvc2VydmVyLWhhbmRzaGFrZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSwyQ0FBMkQ7QUFLM0QsTUFBYSxlQUFlO0lBTXhCLFlBQTJCLE1BQXFCO1FBQXJCLFdBQU0sR0FBTixNQUFNLENBQWU7SUFBRyxDQUFDO0lBTTdDLEtBQUssQ0FBQyxPQUFPLENBQUMsT0FBZTtRQUNoQyxJQUFJLElBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQztZQUNwQixPQUFPO1FBQ1gsQ0FBQztRQUVELE1BQU0sSUFBSSxDQUFDLE1BQU0sQ0FBQyxPQUFPLEVBQUUsQ0FBQztRQUU1QixJQUFJLENBQUMsWUFBWSxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUMsU0FBUyxDQUFDLE9BQU8sR0FBRyx5QkFBYSxFQUFFLEdBQUcsRUFBRTtZQUNwRSxJQUFJLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxPQUFPLEdBQUcseUJBQWEsRUFBRSxFQUFFLENBQUMsQ0FBQztRQUNyRCxDQUFDLENBQUMsQ0FBQztRQUVILElBQUksQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLE9BQU8sR0FBRyx5QkFBYSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3JELENBQUM7SUFLTSxVQUFVO1FBQ2IsSUFBSSxJQUFJLENBQUMsWUFBWSxFQUFFLENBQUM7WUFDcEIsSUFBSSxDQUFDLFlBQVksQ0FBQyxXQUFXLEVBQUUsQ0FBQztZQUNoQyxJQUFJLENBQUMsWUFBWSxHQUFHLEtBQUssQ0FBQyxDQUFDO1FBQy9CLENBQUM7SUFDTCxDQUFDO0NBQ0o7QUFuQ0QsMENBbUNDIn0=